import AuthorizeStore from './AuthorizeStore';

export * from './AuthorizeStore.dto';
export default new AuthorizeStore();
